import { Dispatch, SetStateAction } from "react";

import { useLocalStorage } from "usehooks-ts";

export const useRedirectAfterLogin = (): [
  string,
  Dispatch<SetStateAction<string>>
] => {
  return useLocalStorage<string | undefined>("redirect_after_login", undefined);
};
